package one.healthium.onboarding.ui

import androidx.compose.runtime.Stable
import one.healthium.domain.user.models.AdditionalUserInfoModel
import one.healthium.domain.user.models.Gender
import one.healthium.domain.user.models.UserProfileModel
import one.healthium.onboarding.domain.models.SelectableOption
import one.healthium.onboarding.ui.models.HeightUnit
import one.healthium.onboarding.ui.models.WeightUnit
import one.healthium.onboarding.ui.utils.toUnitString

@Stable
internal data class UserProfileUiModel(
    val name: String? = null,
    val age: Int? = null,
    val weight: Float? = null,
    val selectedWeightUnit: WeightUnit = WeightUnit.Lb,
    val targetWeight: Float? = null,
    val selectedTargetWeightUnit: WeightUnit = WeightUnit.Lb,
    val height: Float? = null,
    val selectedHeightUnit: HeightUnit = HeightUnit.Ft,
    val gender: Gender? = null,
    val additionalInfo: Map<String, List<SelectableOption>> = emptyMap(),
    val additionalText: Map<String, String> = emptyMap(),
    val statements: Map<String, Int> = emptyMap(),
    val isMetric: Boolean = true,
) {

    val currentWeight = weight.toUnitString(selectedWeightUnit, true)

    val model: UserProfileModel by lazy {
        UserProfileModel(
            name = name,
            age = age,
            weight = weight,
            targetWeight = targetWeight,
            height = height,
            gender = gender,
            email = null,
            avatarUrl = null,
            additionalInfo = additionalInfo.mapValues { (_, value) ->
                value.map { selectableOption ->
                    AdditionalUserInfoModel(
                        key = selectableOption.key,
                        text = selectableOption.text.value(gender),
                        altText = selectableOption.altText,
                    )
                }
            },
            additionalText = additionalText,
            statements = statements,
        )
    }

    companion object {
        val preview = UserProfileUiModel(
            name = "Marry Weather",
            age = 35,
            weight = 99f,
            targetWeight = 88f,
            isMetric = true,
        )
    }
}
